module.exports = __webpack_public_path__ + "img/photoboot-telone.f9d816cb.jpg";